<template>
  <footer class="ats-footer" :style="footerStyle">
    <div class="ats-footer__inner">
      <div class="ats-footer__top">
        <router-link class="ats-footer__logo-link" to="/" title="返回官网首页">
          <img
            class="ats-footer__logo"
            :src="assets.footerDibuLogo"
            alt="大救星"
            width="160"
            height="48"
            decoding="async"
          >
        </router-link>
      </div>
      <div class="ats-footer__main">
        <div class="ats-footer__cols">
          <div class="ats-footer__col ats-footer__col--accent">
            <h3 class="ats-footer__col-title">用户登录</h3>
            <img
              class="ats-footer__col-rule-img"
              :src="assets.footerGreenLine"
              alt=""
              role="presentation"
              decoding="async"
            >
            <ul class="ats-footer__links">
              <li><button type="button" class="ats-footer__link" @click="onFooterLink(1)">救援机构</button></li>
              <li><button type="button" class="ats-footer__link" @click="onFooterLink(2)">监管机构</button></li>
              <li><button type="button" class="ats-footer__link" @click="onFooterLink(3)">指挥中心</button></li>
            </ul>
          </div>
          <div class="ats-footer__col">
            <h3 class="ats-footer__col-title">关于我们</h3>
            <img
              class="ats-footer__col-rule-img"
              :src="assets.footerGrayLine"
              alt=""
              role="presentation"
              decoding="async"
            >
            <ul class="ats-footer__links">
              <li><button type="button" class="ats-footer__link" @click="onFooterLink(4)">公司简介</button></li>
              <li><button type="button" class="ats-footer__link" @click="onFooterLink(5)">新闻中心</button></li>
              <li><button type="button" class="ats-footer__link" @click="onFooterLink(6)">合作咨询</button></li>
            </ul>
          </div>
          <div class="ats-footer__col">
            <h3 class="ats-footer__col-title">联系我们</h3>
            <img
              class="ats-footer__col-rule-img"
              :src="assets.footerGrayLine"
              alt=""
              role="presentation"
              decoding="async"
            >
            <ul class="ats-footer__links">
              <li><button type="button" class="ats-footer__link" @click="onFooterLink(7)">意见反馈</button></li>
              <li><span class="ats-footer__text">客服热线：+86-10-83423665</span></li>
              <li><span class="ats-footer__text">指挥中心：+86-10-83423665</span></li>
            </ul>
          </div>
        </div>
        <div class="ats-footer__qr-group">
          <div class="ats-footer__qr">
            <img
              :src="assets.qrWechatOfficial"
              alt="大救星微信公众号二维码"
              width="120"
              height="120"
              loading="lazy"
              decoding="async"
            >
            <p class="ats-footer__qr-label">微信公众号</p>
          </div>
          <div class="ats-footer__qr">
            <img
              :src="assets.qrAppDownload"
              alt="下载大救星 App 二维码"
              width="120"
              height="120"
              loading="lazy"
              decoding="async"
            >
            <p class="ats-footer__qr-label">下载大救星</p>
          </div>
        </div>
      </div>
      <div class="ats-footer__bottom">
        <p class="ats-footer__copy">大救星版权所有©2018-2024</p>
        <a
          class="ats-footer__icp"
          href="http://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >备案号：京ICP备2025140282号-1</a>
      </div>
    </div>
  </footer>
</template>

<script>
import util from '@/util/util.js'

/**
 * 品牌落地页 / 全球救援页 共用页脚
 */
export default {
  name: 'AtsSiteFooter',
  data () {
    return {
      assets: {
        footerDibu: require('@/assets/AbouttheSavior/dibu.png'),
        footerDibuLogo: require('@/assets/AbouttheSavior/dibulog.png'),
        footerGreenLine: require('@/assets/AbouttheSavior/greenline.png'),
        footerGrayLine: require('@/assets/AbouttheSavior/grayline.png'),
        qrWechatOfficial: require('@/components/img/wxgzh.png'),
        qrAppDownload: require('@/components/img/appgzh.png')
      }
    }
  },
  computed: {
    /**
     * 页脚背景：`dibu` 浅色波纹底图（底部对齐，保持比例不裁切）
     * @returns {{ backgroundColor: string, backgroundImage: string, backgroundSize: string, backgroundPosition: string, backgroundRepeat: string }}
     */
    footerStyle () {
      return {
        backgroundColor: '#ffffff',
        backgroundImage: `url(${this.assets.footerDibu})`,
        backgroundSize: '100% auto',
        backgroundPosition: 'center bottom',
        backgroundRepeat: 'no-repeat'
      }
    }
  },
  methods: {
    /**
     * @param {number} id
     * @returns {void}
     */
    onFooterLink (id) {
      const url = util.config.url
      if (id === 1 || id === 2 || id === 3) {
        window.location.href = `${url}/djxwork/#/`
      } else if (id === 4) {
        this.$router.push({ path: '/aboutus', query: { activeName: 'about' } })
        if (this.$root.bus) {
          this.$root.bus.$emit('only', 5)
          this.$root.bus.$emit('about', 'about')
        }
      } else if (id === 5) {
        this.$router.push({ path: '/aboutus', query: { activeName: 'news' } })
        if (this.$root.bus) {
          this.$root.bus.$emit('only', 5)
          this.$root.bus.$emit('about', 'news')
        }
      } else if (id === 6) {
        window.location.href = `${url}/djxwork/#/contact`
      } else if (id === 7) {
        window.location.href = `${url}/djxwork/#/feedback`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './mixins';
$body-grey: #333333;

.ats-footer {
  position: relative;
  color: $body-grey;
  padding: 0 0 24px;
  background-color: #ffffff;
  overflow: hidden;
}

.ats-footer__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 56px 48px 0;
  box-sizing: border-box;
}

.ats-footer__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 40px;
}

.ats-footer__logo-link {
  display: inline-flex;
  text-decoration: none;
  @include ats-hover-icon;

  &:hover {
    opacity: 0.88;
  }
}

.ats-footer__logo {
  display: block;
  width: auto;
  height: 48px;
  max-width: 180px;
  object-fit: contain;
}

.ats-footer__main {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 32px 48px;
  padding-bottom: 40px;
}

.ats-footer__cols {
  flex: 1 1 420px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px 56px;
  min-width: 0;
}

.ats-footer__col-title {
  margin: 0 0 10px;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  color: #333333;
}

.ats-footer__col--accent .ats-footer__col-title {
  color: #256a30;
}

.ats-footer__col-rule-img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 0 18px;
  object-fit: contain;
}

.ats-footer__links {
  list-style: none;
  margin: 0;
  padding: 0;
  li + li {
    margin-top: 12px;
  }
}

.ats-footer__link {
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 14px;
  line-height: 1.6;
  color: #666666;
  cursor: pointer;
  text-align: left;
  @include ats-hover-text-link;
  &:hover {
    color: #256a30;
  }
}

.ats-footer__text {
  display: block;
  font-size: 14px;
  line-height: 1.6;
  color: #666666;
}

.ats-footer__qr-group {
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  gap: 40px;
}

.ats-footer__qr {
  text-align: center;
  img {
    display: block;
    width: 120px;
    height: 120px;
    object-fit: contain;
    margin: 0 auto;
  }
}

.ats-footer__qr-label {
  margin: 12px 0 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: #333333;
}

.ats-footer__bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 0 28px;
  border-top: 1px solid #e8e8e8;
}

.ats-footer__copy {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  color: #333333;
}

.ats-footer__icp {
  font-size: 16px;
  line-height: 1.5;
  color: #333333;
  text-decoration: none;
  @include ats-hover-text-link;
  &:hover {
    color: #256a30;
  }
}

@media (max-width: 960px) {
  .ats-footer__inner {
    padding: 40px 20px 0;
  }
  .ats-footer__top {
    flex-direction: column;
    align-items: flex-start;
  }
  .ats-footer__main {
    flex-direction: column;
  }
  .ats-footer__cols {
    grid-template-columns: 1fr;
    flex: 1 1 100%;
  }
  .ats-footer__qr-group {
    width: 100%;
    justify-content: center;
  }
  .ats-footer__bottom {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ats/AtsSiteFooter.vue